const NON_SUBMITTED_PRIMARY_INVOICE_STATUSES = ["Unsubmitted", "Declined"] as const;

export type PrimaryInvoiceLike = {
  invoice_type?: string;
  invoice_status?: string;
};

export function hasSubmittedPrimaryInvoice(invoices: PrimaryInvoiceLike[] | undefined): boolean {
  if (!invoices?.length) {
    return false;
  }

  return invoices.some(
    (invoice) =>
      invoice.invoice_type === "primary_invoice" &&
      !NON_SUBMITTED_PRIMARY_INVOICE_STATUSES.includes(
        invoice.invoice_status as (typeof NON_SUBMITTED_PRIMARY_INVOICE_STATUSES)[number],
      ),
  );
}

export function shouldShowFinalInvoicePrompt(
  invoices: PrimaryInvoiceLike[] | undefined,
  invoicesReady: boolean,
): boolean {
  if (!invoicesReady) {
    return false;
  }

  return !hasSubmittedPrimaryInvoice(invoices);
}
